import styled from 'styled-components';
import { baseVariables } from '../../utils/TempMiUiLibraryUtils';

const { spacers } = baseVariables;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: ${spacers?.spacers?.[2] ?? '0.5rem'};
  border-block-start: 1px solid var(--t-horizontal-vertical-rule);
`;

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${spacers?.spacers?.[3] ?? '1rem'};
  block-size: 4.625rem;
  inline-size: 100%;
`;

export const HeaderRowImage = styled.div`
  height: 50px;
  width: 100px;
  overflow: hidden;
  flex: none;

  & .m-accordion-item-image {
    width: 100px;
  }
`;

export const HeaderRowText = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;

  & .m-accordion-item-header-text-heading,
  & .m-accordion-item-header-text-body {
    display: block;
    /* stylelint-disable-next-line value-no-vendor-prefix */
    display: -webkit-box;
    max-width: 100%;
    /* stylelint-disable-next-line property-no-vendor-prefix */
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
  }
  & .m-accordion-item-header-text-heading {
    -webkit-line-clamp: 2;
  }
`;

export const Toggle = styled.button`
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;

  &:focus-visible {
    outline: 2px solid var(--t-brand-alt-color);
    outline-offset: 2px;
  }
`;

export const ContentArea = styled.div`
  padding-block-end: ${spacers?.spacers?.[4] ?? '1.5rem'};
  inline-size: 100%;
`;
